import { render, staticRenderFns } from "./DocTypeChip.vue?vue&type=template&id=5df8b338&"
import script from "./DocTypeChip.vue?vue&type=script&lang=js&"
export * from "./DocTypeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports